import pkg from "../../package.json";

/** Versão do app ("1.0.66 DEV"; em produção só o número). */
export const appVersion = `${pkg.version} ${process.env.VUE_APP_ENV_NAME != "PROD" ? process.env.VUE_APP_ENV_NAME : ""}`.trim();
